__webpack_require__.p = "https://alter.ru/_next/";